import React, { createContext, useContext } from "react";
import { gql, useQuery } from "@apollo/client";

interface FeaturesContextType {
  hasFeature: (name: string) => boolean;
  loading: boolean;
}

export const FeaturesContext = createContext<FeaturesContextType>({
  hasFeature: () => false,
  loading: true,
});

const GET_FEATURES = gql`
  query GetFeatures {
    features
  }
`;

interface GetFeaturesResponse {
  features: string[];
}

export const FeaturesProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { data, loading } = useQuery<GetFeaturesResponse>(GET_FEATURES);
  const enabledFeatures = new Set(data?.features ?? []);

  return (
    <FeaturesContext.Provider
      value={{
        hasFeature: (name) => enabledFeatures.has(name),
        loading,
      }}
    >
      {children}
    </FeaturesContext.Provider>
  );
};

export const useFeatures = () => useContext(FeaturesContext);
